module.exports = __webpack_public_path__ + "static/media/Montserrat-ThinItalic.13cf2c4a.ttf";